import { css } from 'styled-system/css';

export const coinsStyles = {
	coin: css({
		_mars: {
			bgColor: 'var(--other-lv2)',
			borderBottom: '1px solid {colors.black.5}',
		},
		
		'.main-wrap__aside &': {
			_mars: {
				rounded: '9px!',
				mb: '6px',
				// for singlebet ticket
				'& + .bet-slip__notice, & + .ticket': {
					roundedTop: '9px',
				}
			}
		},
	}),
	label: css({
		_mars: {
			fontSize: '14px',
		},
	}),
	title: css({
		_mars: {
			color: 'secondary.500',
			fontWeight: '500',
		},
	}),
	text: css({
		_mars: {
			color: 'black.1',
			fontWeight: '400',
		},
	}),
	switchCoin: css({
		_mars: {
			bgColor: 'var(--s500)',
			_active: {
				bgColor: 'brand.500',
			}
		},
	}),
	btnIcon: css({
		_mars: {
			color: 'black.3'
		}
	})
};